module.exports = __webpack_public_path__ + "static/media/bfile-umbrella.ea07b0eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-umbrella.svg
// module id = 1015
// module chunks = 0